export default __webpack_public_path__ + "static/media/mag_drone.4ccce0f0.jpg";